import { render } from "./MessageGroupChatInfo.vue?vue&type=template&id=64ee4398&scoped=true&ts=true"
import script from "./MessageGroupChatInfo.vue?vue&type=script&lang=ts"
export * from "./MessageGroupChatInfo.vue?vue&type=script&lang=ts"

import "./MessageGroupChatInfo.vue?vue&type=style&index=0&id=64ee4398&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ee4398"]])

export default __exports__